import { ChangeEvent, FC } from "react";
import { Flex, Radio, Text } from "@chakra-ui/react";
import { PlanType } from "sdk/types";

export interface RadioInputCustomLabel {
  radioVariant?: string;
  label: string;
  labelProps?: Record<string, unknown>;
  value: PlanType;
}

interface Props extends RadioInputCustomLabel {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioInputCustomLabel: FC<Props> = ({
  onChange,
  radioVariant = "th-outline-2",
  label,
  labelProps,
  value,
}) => {
  return (
    <Flex direction="column" justify="center" w="full">
      <Radio
        mr={2}
        onChange={onChange}
        value={value}
        variant={radioVariant}
        size="xl"
        w="full"
      >
        <Flex align="center" mt="1px" w="full">
          <Text {...labelProps}>{label}</Text>
        </Flex>
      </Radio>
    </Flex>
  );
};
